// Angular
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';

// Afidium
import { GenericFieldset, IGenericFieldset } from '../generic-fieldset.component';

@Component({
    selector: 'remark-fieldset',
    templateUrl: './remark-fieldset.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemarkFieldsetComponent extends GenericFieldset implements IGenericFieldset {
    /** Readonly context can't be modified. Define the context of the fieldset */
    public readonly context: string = 'remark';

    constructor (public fb: FormBuilder) {
        super(fb);
    }
}
